<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="text-dark">{{ translationService.getTranslation('Forms Setup') }}</h3>
    </div>
    
    <ul class="nav nav-tabs mb-2 d-flex justify-content-center">
      <li class="nav-item ms-3">
        <a class="nav-link"
           [ngClass]="{
             'text-success border border-success fw-bold': activeTab === 'new',
             'text-muted': activeTab !== 'new'
           }"
           [class.active]="activeTab === 'new'"
           (click)="setActiveTab('new')">
          {{ translationService.getTranslation('New Forms') }}
        </a>
      </li>
      <li class="nav-item ms-3">
        <a class="nav-link"
           [ngClass]="{
             'text-success border border-success fw-bold': activeTab === 'view',
             'text-muted': activeTab !== 'view'
           }"
           [class.active]="activeTab === 'view'"
           (click)="setActiveTab('view')">
          {{ translationService.getTranslation('View Forms') }}
        </a>
      </li>
      <li class="nav-item ms-3">
        <a class="nav-link text-secondary">{{ translationService.getTranslation('Remove Forms') }}</a>
      </li>
    </ul>
       

    <div *ngIf="activeTab === 'new'">
      <div *ngIf="!FormGenerating">
        <div class="py-2 row flex-wrap">
          <div class="w-25">
            <label class="form-label mb-2">{{ translationService.getTranslation('Select Folder') }}:</label>
            <select class="form-control" (change)="onFolderChange($event.target.value)">
              <option value="" disabled selected>{{ translationService.getTranslation('Select Folder') }}</option>
              <option *ngFor="let folder of allExamFolders" [value]="folder.ID">{{ folder["Course Name"] }}</option>
            </select>
          </div>
        </div>
        <div class="table-responsive pt-2">
          <table class="table table-bordered table-striped table-hover">
            <thead class="table-success">
              <tr>
                <th class="col-3">{{ translationService.getTranslation('Unit Name') }}</th>
                <th class="col-1 text-center">{{ translationService.getTranslation('Item Per Unit') }}</th>
                <th class="col-1 text-center" *ngFor="let type of questionTypes">{{ type }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let unit of unitsList">
                <td><b>{{ unit['Unit Name'] }}</b></td>
                <td>
                  <input type="number" [(ngModel)]="unit['Item Per Unit']" 
                         (input)="validateItemPerUnit($event, unit)" 
                         class="form-control text-center" maxlength="2">
                </td>
                
                <td *ngFor="let type of questionTypes">
                  <input type="number" [(ngModel)]="unit[type]" 
                        (input)="validateQuestionTypeInput($event, unit, type)" 
                        class="form-control text-center" maxlength="2"
                        [disabled]="!unit['Item Per Unit']">
                
                  <div class="text-success text-center fw-bold mt-1 small" style="font-size: 0.7rem; line-height: 1.2;">
                    {{ translationService.getTranslation('Total Questions') }}: {{ getQuestionCountForUnit(unit, type) }}
                  </div>    
                </td>
                
                
              </tr>
            </tbody>
          </table>
        </div>
      
        <div class="mt-3">
          <b>{{ translationService.getTranslation('Total Number of Questions') }}: </b>{{ totalQuestions }} / 50
        </div>
      
        <button class="btn btn-success mt-4" *ngIf="totalQuestions == 50" (click)="generateQuestions()"><i class="bi bi-database-gear"></i> {{ translationService.getTranslation('Generating Questions') }} </button>
      </div>     

      <div *ngIf="FormGenerating">
        <div class="d-flex justify-content-between mb-3">
          <button class="btn btn-outline-warning" (click)="refreshForm()">
            <i class="bi bi-arrow-clockwise me-2"></i> {{ translationService.getTranslation('Refresh') }}
          </button>
          <button class="btn btn-outline-danger" (click)="backToFormSetup()">
            <i class="bi bi-arrow-left-circle me-2"></i> {{ translationService.getTranslation('Back') }}
          </button>
        </div>

        <h4>{{ selectedFolderName }}</h4>
        <div class="mb-2">
          {{ translationService.getTranslation('This Form has') }}:
          <span *ngFor="let level of Level_BASE; let last = last">
            <u><b>{{ level.count }} Questions {{ level.level }}</b></u>
            <span *ngIf="!last">, </span>
          </span>
        </div>
           
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-hover">
            <thead class="table-success">
              <tr>
                <th scope="col">{{ translationService.getTranslation('#') }}</th>
                <th scope="col">{{ translationService.getTranslation('ID') }}</th>
                <th scope="col">{{ translationService.getTranslation('Question') }}</th>
                <th scope="col">{{ translationService.getTranslation('Question Type') }}</th>
                <th scope="col">{{ translationService.getTranslation('Question Level') }}</th>
                <th scope="col">{{ translationService.getTranslation('Folder Unit') }}</th>
                <th scope="col">{{ translationService.getTranslation('Answers') }}</th>
                <th scope="col">{{ translationService.getTranslation('Refresh') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let question of FormQuestions; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ question.QuestionID }}</td>
                <td>{{ question.QuestionText }}</td>
                <td>{{ question.QuestionType }}</td>
                <td>{{ question.QuestionLevel }}</td>
                <td>{{ question.UnitName }}</td>
                <td class="text-center">
                  <button class="btn btn-outline-primary" (click)="viewItem(question)">
                    <i class="bi bi-eye"></i>
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn btn-outline-success" (click)="refreshQuestion(question)">
                    <i class="bi bi-arrow-clockwise"></i>
                  </button>
                </td>
              </tr>
              
            </tbody>
          </table>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="mx-1 col-1">
            <input class="form-control text-center" [value]="selectedFormNo" disabled>
          </div>
          <button class="btn btn-success" (click)="saveForm()">
            <i class="bi bi-floppy"></i> {{ translationService.getTranslation('Save This Form') }}
          </button>
        </div>                         
      </div>
    </div>
    
    <div *ngIf="activeTab === 'view'">
      <div class="py-2 row flex-wrap">
        <div class="w-25">
          <label class="form-label mb-2">{{ translationService.getTranslation('Select Folder') }}:</label>
          <select class="form-control" (change)="onFolderChange($event.target.value)">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Folder') }}</option>
            <option *ngFor="let folder of allExamFolders" [value]="folder.ID">{{ folder["Course Name"] }}</option>
          </select>
        </div>
        <div class="w-25">
          <label class="form-label mb-2">{{ translationService.getTranslation('Select Form Number') }}:</label>
          <select class="form-control" [(ngModel)]="selectedFormNo">
            <option *ngFor="let formID of FormIDs" [value]="formID">{{ formID }}</option>
          </select>
        </div>
        <div class="w-25">
          <label class="form-label mb-2">{{ translationService.getTranslation('Select Language') }}:</label>
          <select class="form-select form-control" name="language" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedFormlanguage">
            <option *ngFor="let language of filteredLanguagesList" [value]="language.LanguageID">{{ language.LanguageName }}</option>
          </select>
        </div>
        <div class="w-25" style="padding-top: 32px;">
          <div class="mb-1">
            <button class="btn btn-success w-100" (click)="getQuestions()" [disabled]="!selectedFormlanguage || !selectedFormNo">{{ translationService.getTranslation('Get Questions') }}</button>
          </div>
          <div>
            <button class="btn btn-success w-100" (click)="startTestExam()" [disabled]="!FormQuestions.length > 0">{{ translationService.getTranslation('Start Trial Exam') }}</button>
          </div>
        </div>
      </div>

      <div class="mb-2" *ngIf="FormQuestions.length > 0">
        {{ translationService.getTranslation('This Form has') }}:
        <span *ngFor="let item of Level_BASE">
          <u><b>{{ item.count }} Questions {{ item.level }}</b></u>,
        </span>
      </div>
      
  
      <div class="table-responsive pt-2">
        <table class="table table-bordered table-striped table-hover">
          <thead class="table-success">
            <tr>
              <th scope="col">{{ translationService.getTranslation('#') }}</th>
              <th scope="col">{{ translationService.getTranslation('ID') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question Type') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question Level') }}</th>
              <th scope="col">{{ translationService.getTranslation('Action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let question of FormQuestions; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ question.QuestionID }}</td>
              <td>{{ question.QuestionText }}</td>
              <td>{{ question.QuestionType }}</td>
              <td>{{ question.QuestionLevel }}</td>
              <td class="text-center">
                <button class="btn btn-outline-primary" (click)="viewItem(question)">
                  <i class="bi bi-eye"></i>
                </button>
              </td>     
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- not yet..! -->
    <div *ngIf="activeTab === 'remove'"> 
      <div class="py-2 row flex-wrap">
        <div class="w-25">
          <label class="form-label mb-2">Select Folder:</label>
          <select class="form-control" (change)="onFolderChange($event.target.value)">
            <option value="" disabled selected>{{ translationService.getTranslation('Select Folder') }}</option>
            <option *ngFor="let folder of allExamFolders" [value]="folder.ID">{{ folder["Course Name"] }}</option>
          </select>
        </div>
        <div class="w-25">
          <label class="form-label mb-2">Select Form Language:</label>
          <select class="form-select form-control" name="language" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedFormlanguage">
            <option *ngFor="let language of filteredLanguagesList" [value]="language.LanguageID">{{ language.LanguageName }}</option>
          </select>
        </div>
        <div class="w-25" style="padding-top: 32px;">
          <div class="mb-1">
            <button class="btn btn-success w-100" (click)="getQuestions()" [disabled]="!selectedFormlanguage || !selectedFormNo">Get Forms</button>
          </div>
        </div>
      </div>
  
      <div class="table-responsive pt-2">
        <table class="table table-bordered table-striped table-hover">
          <thead class="table-success">
            <tr>
              <th scope="col">{{ translationService.getTranslation('#') }}</th>
              <th scope="col">{{ translationService.getTranslation('ID') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question Type') }}</th>
              <th scope="col">{{ translationService.getTranslation('Question Level') }}</th>
              <th scope="col">{{ translationService.getTranslation('Action') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let question of FormQuestions; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ question.QuestionID }}</td>
              <td>{{ question.QuestionText }}</td>
              <td>{{ question.QuestionType }}</td>
              <td>{{ question.QuestionLevel }}</td>
              <td class="text-center">
                <button class="btn btn-outline-primary" (click)="viewItem(question)">
                  <i class="bi bi-eye"></i>
                </button>
              </td>     
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <div *ngIf="showViewModal" class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showViewModal ? 'false' : 'true'">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-success text-white">
                <h5 class="modal-title"><i class="bi bi-eye"></i> {{ translationService.getTranslation('View Question') }}</h5>
                <button type="button" class="btn-close" (click)="closeModal()"></button>
            </div>
            <div class="modal-body">
                <table class="table table-bordered table-striped">
                  <tr>
                      <th class="p-2"><i class="bi bi-file-earmark-text"></i> {{ translationService.getTranslation('Question ID') }}</th>
                      <td>{{ selectedQuestion.QuestionID }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-folder"></i> {{ translationService.getTranslation('Folder Name') }}</th>
                      <td>{{ selectedFolderName }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-box"></i> {{ translationService.getTranslation('Unit Name') }}</th>
                      <td>{{ selectedQuestion.UnitName }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-file-earmark-code"></i> {{ translationService.getTranslation('Question Type') }}</th>
                      <td>{{ selectedQuestion.QuestionType }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-globe"></i> {{ translationService.getTranslation('Language') }}</th>
                      <td>{{ selectedFormlanguage }}</td>
                  </tr>
                  <tr>
                      <th class="p-2"><i class="bi bi-circle"></i> {{ translationService.getTranslation('Question Level') }}</th>
                      <td>{{ selectedQuestion.QuestionLevel }}</td>
                  </tr>
                  <tr>
                      <th class="p-2 "><i class="bi bi-chat-text"></i> {{ translationService.getTranslation('Question Content') }}</th>
                      <td class="fw-bold">{{ selectedQuestion.QuestionText }}
                        <i 
                        class="bi bi-volume-up text-success" 
                        role="button" 
                        (click)="playAudio(selectedQuestion.QuestionText, selectedFormlanguage)"
                        style="cursor: pointer; font-size: 1.1rem;">
                      </i>
                      </td>
                  </tr>
              </table>                
                <h6 *ngIf="selectedQuestion.ImageLink || selectedQuestion.VideoLink" class="text-success"><i class="bi bi-camera-video"></i> {{ translationService.getTranslation('Media') }}:</h6>
                <div class="row mt-3">
                  <div class="col-md-12 d-flex gap-3">
                    <div *ngIf="selectedQuestion.ImageLink">
                      <img src="{{getImageLink + this.selectedQuestion.ImageLink}}" class="img-thumbnail" style="width: 450px; height: 250px;" />
                    </div>
                    <div *ngIf="selectedQuestion.VideoLink">
                      <video controls class="img-thumbnail" style="width: 450px; height: 250px;">
                        <source src="{{getVideoLink + this.selectedQuestion.VideoLink}}" type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
                <h6 class="text-success"><i class="bi bi-pencil-square"></i> {{ translationService.getTranslation('Answers') }}:</h6>
                <div class="list-group">
                  <div *ngFor="let answer of selectedQuestion.Answers; let i = index" class="list-group-item d-flex justify-content-between align-items-center p-2">
                    <span class="fw-bold">
                      <span *ngIf="this.selectedQuestion.QuestionType === 'Ordering'" class="badge text-bg-success p-2 mx-2">{{ i+1 }}</span>
                      <i *ngIf="answer.IsCorrect === true" class="bi bi-check-circle"></i>
                      {{ answer.AnswerText }}
                      <i 
                      class="px-2 bi bi-volume-up text-success" 
                      role="button" 
                      (click)="playAudio(answer.AnswerText, selectedFormlanguage)"
                      style="cursor: pointer; font-size: 1.3rem;">
                    </i>
                      <div *ngIf="answer.ImageLink !== null">
                        <img src="{{getImageLink + answer.ImageLink}}" class="img-thumbnail" style="width: 250px; height: 250px;" />
                      </div>
                    </span>
                  </div>                                                                                           
                </div>                  
            </div>
        </div>
    </div>
  </div>

  <div *ngIf="showTestExam" class="modal fade show" style="display: block;" tabindex="0" [attr.aria-hidden]="showViewModal ? 'false' : 'true'">
    <div class="modal-dialog modal-lg" style="max-width: 90%; width: 90%;">
      <div class="modal-content">
        <div class="modal-header bg-success text-white">
          <h5 class="modal-title"><i class="bi bi-eye"></i> {{ translationService.getTranslation('Start Trial Exam') }}</h5>
          <button type="button" class="btn-close" (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
          <div *ngIf="!isExamCompleted">

            <div class="d-flex justify-content-between mb-2">
              <div>
                <h2>{{ selectedFolderName }} - {{ translationService.getTranslation('Start Trial Exam') }}</h2>
                <h6>{{ translationService.getTranslation('Candidte Name') }}: {{ username }}</h6>
                <h6>{{ translationService.getTranslation('Exam Attendance Number') }}: {{ examAttendanceNumber }}</h6>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="border border-3 border-success rounded-circle text-center p-4 fs-5 fw-bold">
                  {{ formatTime(remainingTime) }}
                </div>
              </div>
             </div>
  
             <div class="card" [dir]="selectedFormlanguage ? 'rtl' : 'ltr'">
              <div class="card-body">
                <div *ngIf="AnswersDto?.length > 0" class="progress-container mb-3">
                  <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
                         role="progressbar" 
                         [style.width.%]="progressPercentage"
                         aria-valuenow="{{ progressPercentage }}" 
                         aria-valuemin="0" 
                         aria-valuemax="100">
                    </div>
                  </div>
                </div>
                
                
                <div class="d-flex align-items-center mb-4">
                  <h4 class="me-2 mb-0 flex-grow-1">
                    <span>{{ currentQuestionIndex+1 }}</span> - {{ currentQuestionText }}
                    <i class="bi bi-volume-up text-success mx-2" role="button" 
                       (click)="playAudio(currentQuestionText, selectedFormlanguage)" 
                       style="cursor: pointer; font-size: 1.5rem;">
                    </i>
                  </h4>
                  <div
                    class="border border-3 rounded-circle text-center p-4 fs-5 fw-bold"
                    [ngClass]="{
                      'text-success': remainingTimePerQuestion >= 20,
                      'border-success': remainingTimePerQuestion >= 20,
                      'text-danger': remainingTimePerQuestion < 20,
                      'border-danger': remainingTimePerQuestion < 20
                    }">
                    {{ formatTime(remainingTimePerQuestion) }}
                  </div>
                </div>
                
                
                
                
                <div *ngIf="QuestionContent && (QuestionContent.ImageLink || QuestionContent.VideoLink)" class="mb-3">
                  <div *ngIf="QuestionContent.ImageLink" class="text-center">
                    <img [src]="getImageLink + QuestionContent.ImageLink" class="img-thumbnail w-50" />
                  </div>
                  <div *ngIf="QuestionContent.VideoLink" class="text-center">
                    <video *ngIf="currentQuestionIndex" id="questionVideo" controls class="img-thumbnail w-50">
                      <source [src]="getVideoLink + QuestionContent.VideoLink + '?t=' + currentQuestionIndex" type="video/mp4" />
                    </video>
                  </div>                                                    
                </div>
                
                
                <div *ngIf="QuestionContent && (['TF', 'MCQ', 'MCQImages', 'RightOrWrongImage', 'RightOrWrongVideo'].includes(QuestionContent.QuestionType))">
                  <div *ngFor="let answer of AnswersDto; let i = index" class="mb-3 d-flex align-items-center">
                    <div class="answer-container d-flex align-items-center mb-2">
                      <button 
                        class="btn w-100 text-start btn-outline-success me-2" 
                        [class.btn-success]="selectedAnswer === answer.AnswerID"
                        [class.text-light]="selectedAnswer === answer.AnswerID"
                        (click)="selectAnswer(answer.AnswerID)">
                        
                        <div *ngIf="QuestionContent.QuestionType !== 'MCQImages'">
                          <span>{{ answer.AnswerText }}</span>
                        </div>
                    
                        <div *ngIf="QuestionContent.QuestionType === 'MCQImages'" class="text-center">
                          <div 
                            class="img-thumbnail mx-auto d-flex justify-content-center align-items-center"
                            [ngStyle]="{
                              'background-image': 'url(' + getImageLink + answer.ImageLink + ')',
                              'background-size': 'cover',
                              'background-position': 'center',
                              'width': '180px',
                              'height': '180px',
                            }"
                            (contextmenu)="$event.preventDefault()">
                          </div>
                          <div class="pt-1 fw-bold">  
                            <span>{{ answer.AnswerText }}</span>
                          </div>
                        </div>
                      </button>
                      <i
                        class="bi bi-volume-up text-success mx-2" 
                        role="button" 
                        (click)="playAudio(answer.AnswerText, selectedFormlanguage)" 
                        style="cursor: pointer; font-size: 1.5rem;">
                      </i>
                    </div>
                  </div>
                                
                  <div class="my-3" [dir]="!selectedFormlanguage ? 'rtl' : 'ltr'">
                    <button class="btn btn-outline-success fw-bold btn-lg"
                      [disabled]="selectedAnswer == null" 
                      (click)="goToNextQuestion()">
                      {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
                    </button>
                  </div>
                </div>
                
        
                <div *ngIf="QuestionContent && (QuestionContent.QuestionType === 'MultiAnswers')">
                  <div *ngFor="let answer of AnswersDto; let i = index" class="mb-3 d-flex align-items-center">
                    <div class="answer-container d-flex align-items-center mb-2">
                      <button 
                        class="btn w-100 text-start btn-outline-success" 
                        [class.btn-success]="selectedAnswers.includes(answer.AnswerID)"
                        [class.text-light]="selectedAnswers.includes(answer.AnswerID)"
                        (click)="selectAnswer(answer.AnswerID, 'MultiAnswers')">
                        {{ answer.AnswerText }}
                      </button>
                      <i class="bi bi-volume-up text-success mx-2" 
                        role="button" 
                        (click)="playAudio(answer.AnswerText, selectedFormlanguage)" 
                        style="cursor: pointer; font-size: 1.5rem;">
                      </i>
                    </div>
                  </div>
        
                  <div class="my-3" [dir]="!selectedFormlanguage ? 'rtl' : 'ltr'">
                    <button class="btn btn-outline-success fw-bold btn-lg" 
                      [disabled]="selectedAnswers.length < 1" 
                      (click)="goToNextQuestion()">
                      {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
                    </button>
                  </div>
                </div>
        
        
                <div *ngIf="QuestionContent && (QuestionContent.QuestionType === 'Ordering')">
                  <div cdkDropListGroup>
                    <div class="row">
        
                      <div class="col-md-6">
                        <div class="bg-light p-3 border rounded">
                          <p class="text-success fw-bold text-center">{{ translationService.getTranslation('Drag and arrange the steps into the square on the left') }}
                            <i class="bi bi-volume-up text-success me-2" role="button" 
                              (click)="playAudio(translationService.getTranslation('Drag and arrange the steps into the square on the left'), selectedFormlanguage)" 
                              style="cursor: pointer; font-size: 1rem;">
                            </i>
                          </p>
                          <div cdkDropList [cdkDropListData]="AnswersDto" (cdkDropListDropped)="drop($event)">
                            <div *ngFor="let answer of AnswersDto; trackBy: trackItem" class="border border-2 border-success text-center p-2 mb-2" cdkDrag>
                              {{ answer.AnswerText }}
                              <i class="bi bi-volume-up text-success me-2" role="button" (click)="playAudio(answer.AnswerText, selectedFormlanguage)" style="cursor: pointer; font-size: 1rem;">
                            </i>
                            </div>
                          </div>
                        </div>
                      </div>
        
                      <div class="col-md-6">
                        <div class="bg-light p-3 border rounded">
                      
                          <div cdkDropList [cdkDropListData]="selectedAnswers" (cdkDropListDropped)="drop($event)">
                            <div class="d-flex justify-content-between text-cealign-items-center mb-2">
                              <p class="text-success fw-bold">{{ translationService.getTranslation('Arrange the answers in the correct sequence') }}
                                <i class="bi bi-volume-up text-success me-2" role="button" 
                                (click)="playAudio(translationService.getTranslation('Arrange the answers in the correct sequence'), selectedFormlanguage)" 
                                style="cursor: pointer; font-size: 1rem;">
                              </i>
                              </p>
                              <button class="btn btn-outline-danger btn-sm" (click)="resetOrdering()">
                                {{translationService.getTranslation('Resest')}}<i class="bi bi-arrow-clockwise mx-1"></i>
                              </button>
                            </div>
                            
                      
                            <div *ngFor="let item of selectedAnswers; let i = index; trackBy: trackItem" class="d-flex align-items-center mb-2" cdkDrag>
                              <div class="me-3 bg-secndary text-success text-center p-2 rounded fs-5 fw-bold">
                                {{ i + 1 }}
                              </div>
                              <div
                                class="d-inline-block border border-2 bg-success text-white text-center p-2"
                                cdkDropList
                                [cdkDropListData]="item.AnswerText"
                                (cdkDropListDropped)="drop($event, i)">
                                {{ item.AnswerText }}
                                <i class="bi bi-volume-up text-white me-2" 
                                   role="button" 
                                   (click)="playAudio(item.AnswerText, selectedFormlanguage)" 
                                   style="cursor: pointer; font-size: 1rem;">
                                </i>
                              </div>
                            </div>
                          </div>
                      
                        </div>
                      </div>              
                    </div>
                  </div>
                  
                  <div class="my-3" [dir]="!selectedFormlanguage ? 'rtl' : 'ltr'">
                    <button class="btn btn-outline-success fw-bold btn-lg"  
                      [disabled]="AnswersDto.length > 0" 
                      (click)="goToNextQuestion()">
                      {{ currentQuestionIndex == totalQuestions -1 ? translationService.getTranslation('Finish the Exam') : translationService.getTranslation('Go to Question') + ' ' + (currentQuestionIndex + 2) }}
                    </button>
                  </div>
                </div>
                
              <div class="mt-5 d-flex justify-content-between" [dir]="!selectedFormlanguage ? 'rtl' : 'ltr'">
                <button class="btn btn-outline-warning me-2" (click)="skipQuestion()" [disabled]="skipCount < 1">
                  {{ translationService.getTranslation('Skip The Question') }} {{skipCount}} {{ translationService.getTranslation('Remaining') }}
                </button>
                <button class="btn btn-outline-info" (click)="postponeQuestion()" [disabled]="postponeCount < 1">
                  {{ translationService.getTranslation('Postpone The Question') }} {{postponeCount}} {{ translationService.getTranslation('Remaining') }}
                </button>
              </div>
        
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>